import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import Navbar from '@App/components/Navbar/Navbar';
import DatapanelToggle from '@App/components/DatapanelToggle/DatapanelToggle';
import MaplibreMap from '@library/MaplibreMap/MaplibreMap';
import LocationSearchControlPortal from '@App/components/LocationSearch/LocationSearchControlPortal';
import MapInstructionCard from '@App/components/MapInstructionCard/MapInstructionCard';
import ScreenNotSupported from '@App/components/ScreenNotSupported/ScreenNotSupported';

import { setAdaptationDatapanelExpanded } from '@library/GuidedTour/guided-tour.slice';

import './adaptation-page.styl';

function AdaptationPage() {
  const dispatch = useDispatch();
  const [map, setMap] = useState(null);
  const [mapResizeId] = useState();
  const datapanelExpanded = useSelector(state => state.guidedTour.adaptationDatapanelExpanded);
  const locationCoordinates = useSelector(state => state.maplibremap.locationCoordinates);

  const location = useLocation();
  const currentPath = location.pathname;
  const toggleDatapanel = () => dispatch(setAdaptationDatapanelExpanded(!datapanelExpanded));

  const showMapInstructionCard = currentPath.split('/').includes('create') && (!locationCoordinates?.lat || !locationCoordinates?.lng);
  
  return (
    <div className="adaptation-page">
      <ScreenNotSupported />
      <Navbar />
      <div className={`adaptation-page__wrapper ${datapanelExpanded ? 'adaptation-page__wrapper--expanded' : 'adaptation-page__wrapper--collapsed'}`}>
        <div className={`adaptation-page__datapanel ${datapanelExpanded ? 'adaptation-page__datapanel--expanded' : 'inset'}`}>
          <DatapanelToggle
            expanded={datapanelExpanded}
            onToggle={toggleDatapanel}
            variant="mobile"
            className="adaptation-page__datapanel-toggle"
            buttonClassName="adaptation-page__datapanel-toggle__mobile"
          />
          <Outlet context={{ map }} />
        </div>
        <div className="adaptation-page__map">
          <DatapanelToggle
            expanded={datapanelExpanded}
            onToggle={toggleDatapanel}
            variant="desktop"
            className="adaptation-page__datapanel-toggle__desktop"
          />
          <MaplibreMap
            mapResizeId={mapResizeId}
            onMapInitialized={setMap}
          />
          {showMapInstructionCard && (
            <MapInstructionCard path={currentPath} />
          )}
          <LocationSearchControlPortal map={map} />
        </div>
      </div>
    </div>
  );
}

export default AdaptationPage;
